export default "__VITE_ASSET__ConPtDsn__"